import { useIssue492AbTestStore } from '@/store/ab_test_issue_492'
import { ISSUE_492_V2_AB_TEST_CONFIG } from '@/utils/abtest/abTestConfig'
import useABTestV2 from '@/utils/abtest/useABTestV2'

export function useIssue492AbTest() {
  const store = useIssue492AbTestStore()

  const initialize = () => {
    store.abTestResult = useABTestV2(ISSUE_492_V2_AB_TEST_CONFIG)
  }

  const pattern = computed<'a' | 'b' | null>(() => {
    const result = store.abTestResult
    if (!result) return null
    if (result.isAPattern) return 'a'
    if (result.isBPattern) return 'b'
    return null
  })

  return {
    initialize,
    pattern
  }
}
